const bcryptjs = require('bcryptjs');

export const getHash = async (password) => bcryptjs.hashSync(password, 10);

export const compareHash = async (password, hash) => {
    return bcryptjs.compareSync(password, hash);
}